import { PdfWorkFormType } from '../enums/pdf-work-form-type.enum';

export class PdfWorkFormTypeHelper {
  public static buildPdfMergeNotificationCardMessage(length: number, pdfDocumentType: PdfWorkFormType): string | undefined {
    let msg: { msgPlural: string | undefined; msgSingular: string | undefined } = { msgPlural: undefined, msgSingular: undefined };

    if (pdfDocumentType === PdfWorkFormType.WorkFormWithParams) {
      msg = {
        msgPlural: `PDF de ${length} bons de travail`,
        msgSingular: `PDF de ${length} bon de travail`,
      };
    } else if (pdfDocumentType === PdfWorkFormType.WorkForm) {
      msg = {
        msgPlural: `PDF de ${length} bons de travail`,
        msgSingular: `PDF de ${length} bon de travail`,
      };
    } else if (pdfDocumentType === PdfWorkFormType.WorkFormLabelTag23x23) {
      msg = {
        msgPlural: `PDF de ${length} étiquettes de travail`,
        msgSingular: `PDF de ${length} étiquette de travail`,
      };
    } else if (pdfDocumentType === PdfWorkFormType.WorkFormLabelTag89x28) {
      msg = {
        msgPlural: `PDF de ${length} étiquettes de travail`,
        msgSingular: `PDF de ${length} étiquette de travail`,
      };
    }

    const message = length > 1 ? msg.msgPlural : msg.msgSingular;
    return message;
  }

  public static buildPdfMergeNotifyMessage(length: number, pdfDocumentType: PdfWorkFormType): string | undefined {
    let msg: { msgPlural: string | undefined; msgSingular: string | undefined } = { msgPlural: undefined, msgSingular: undefined };
    if (pdfDocumentType === PdfWorkFormType.WorkFormWithParams) {
      msg = {
        msgPlural: `PDF multiple de ${length} bons de travail en cours de génération`,
        msgSingular: `PDF multiple de ${length} bon de travail en cours de génération`,
      };
    } else if (pdfDocumentType === PdfWorkFormType.WorkForm) {
      msg = {
        msgPlural: `PDF multiple de ${length} bons de travail en cours de génération`,
        msgSingular: `PDF multiple de ${length} bon de travail en cours de génération`,
      };
    } else if (pdfDocumentType === PdfWorkFormType.WorkFormLabelTag23x23) {
      msg = {
        msgPlural: `PDF multiple de ${length} étiquettes de travail en cours de génération`,
        msgSingular: `PDF multiple de ${length} étiquette de travail en cours de génération`,
      };
    } else if (pdfDocumentType === PdfWorkFormType.WorkFormLabelTag89x28) {
      msg = {
        msgPlural: `PDF multiple de ${length} étiquettes de travail en cours de génération`,
        msgSingular: `PDF multiple de ${length} étiquette de travail en cours de génération`,
      };
    }

    const message = length > 1 ? msg.msgPlural : msg.msgSingular;
    return message;
  }

  public static translateEnum(enumValue: PdfWorkFormType, pluralFlag = false): string | undefined {
    if (enumValue === PdfWorkFormType.WorkForm) {
      return pluralFlag ? 'Bons de travail' : 'Bon de travail';
    } else if (enumValue === PdfWorkFormType.WorkFormLabelTag23x23) {
      return pluralFlag ? 'Etiquettes de travail (23x23mm)' : 'Etiquette de travail (23x23mm)';
    } else if (enumValue === PdfWorkFormType.WorkFormLabelTag89x28) {
      return pluralFlag ? 'Etiquettes de travail (89x28mm)' : 'Etiquette de travail (89x28mm)';
    }
    return undefined;
  }
}
